export default __webpack_public_path__ + "static/media/testimonial-avatar-1.9b3d8339.jpg";